<template>
  <div>
    <delete-group-modal
      :group="toBeDeletedGroup"
      @group-deleted="fetchGroups"
    />
    <div class="d-flex justify-content-end mb-1">
      <b-button
        variant="flat-primary"
        @click="showGroupsForm = !showGroupsForm"
      >
        <feather-icon
          :icon="showGroupsForm ? 'XIcon' : 'PlusCircleIcon'"
          size="20"
        />
      </b-button>
    </div>
    <groups-form
      v-if="showGroupsForm"
      @created="() => {
        showGroupsForm = false;
        fetchGroups()
      }"
    />
    <b-spinner
      v-if="fetching"
      variant="primary"
    />
    <h6 v-if="!fetching && !groups.length">
      No modifier groups yet..
    </h6>
    <CardCollapse
      v-for="group in groups"
      :key="group.id"
    >
      <template #card-title>
        <h3 class="mr-2">
          {{ group.name.en + ' / '+ group.name.ar }}
          <small>( {{ snakeCaseToCamelCase(group.state) }} )</small>
          <small class="text-muted">{{ group.requestedChange && '(Pending Changes)' }}</small>
        </h3>
      </template>
      <template v-if="group.state == 'APPROVED' && !group.requestedChange">
        <b-button
          class="btn-icon rounded-circle"
          variant="flat-danger"
          @click="openDeleteGroupPopup(group)"
        >
          <feather-icon
            icon="TrashIcon"
          />
        </b-button>
        <b-button
          class="btn-icon rounded-circle"
          variant="flat-primary"
          @click="group.showEditForm = !group.showEditForm"
        >
          <feather-icon
            :icon="group.showEditForm ? 'XIcon' : 'EditIcon'"
          />
        </b-button>
      </template>
      <groups-form
        v-if="group.showEditForm"
        :group="group"
        @updated="fetchGroups"
      />
      <b-row>
        <b-col md="3">
          <h5>Required</h5>
          <h6>{{ group.rules && group.rules.required ? 'Yes' : 'No' }}</h6>
        </b-col>
        <b-col md="3">
          <h5>Maximum allowed selections</h5>
          <h6 class="text-center">
            {{ group.rules && group.rules.maximumAllowedSelection }}
          </h6>
        </b-col>
        <b-col md="3">
          <h5>Minimum allowed selections</h5>
          <h6 class="text-center">
            {{ group.rules && group.rules.minimumNumberOfSelections }}
          </h6>
        </b-col>
        <b-col md="3">
          <h5>Multiple Selection</h5>
          <h6>{{ group.rules && group.rules.allowMultipleSelections ? 'Yes': 'No' }}</h6>
        </b-col>
        <b-col
          md="12"
          class="mt-1"
        >
          <h6>Selections</h6>
          <h5 v-if="!group.selections.length">
            No selections for this group yet
          </h5>
          <b-row
            v-for="selection in group.selections"
            :key="selection.id"
            class="d-flex align-items-center mb-1"
          >
            <b-col md="4">
              <h6>{{ selection.name.en }} / {{ selection.name.ar }}</h6>
            </b-col>
            <b-col md="2">
              <h6>
                JOD {{ selection.price }}
              </h6>
            </b-col>
          </b-row>

        </b-col>
      </b-row>
    </CardCollapse>
  </div>
</template>

<script>
import { ref } from '@vue/composition-api'
import {
  BSpinner, BRow, BCol, BButton,
} from 'bootstrap-vue'
import CardCollapse from '@/UI/CardCollapse.vue'
import GroupsForm from './menu-management/GroupsForm.vue'
import snakeCaseToCamelCase from '@/utils/snake-case-to-camcel-caase'
import DeleteGroupModal from './menu-management/DeleteGroupModal.vue'

export default {
  components: {
    BSpinner,
    BRow,
    BCol,
    CardCollapse,
    GroupsForm,
    BButton,
    DeleteGroupModal,
  },
  setup(_, ctx) {
    const showGroupsForm = ref(false)
    const groups = ref([])
    const businessId = ctx.root.$route.params.id
    const fetching = ref(false)
    const fetchGroups = async () => {
      groups.value = []
      fetching.value = true
      const res = await ctx.root.$store.dispatch('business/getBusinessSelectionGroups', {
        businessId,
      })
      const data = res.data.data.data.map(g => ({
        ...g,
        showEditForm: false,
      }))
      groups.value = data
      fetching.value = false
    }

    fetchGroups()

    const toBeDeletedGroup = ref({})
    const openDeleteGroupPopup = group => {
      toBeDeletedGroup.value = group
      ctx.root.$bvModal.show('delete-group-modal')
    }

    return {
      toBeDeletedGroup,
      openDeleteGroupPopup,
      showGroupsForm,
      fetching,
      groups,
      snakeCaseToCamelCase,
      fetchGroups,
    }
  },
}
</script>

<style>

</style>
